<template>
  <div class="page projects">
    <div v-if="featured" class="projects__featured">
      <vimeo-embed :url="featured.content[0]" v-if="isVimeo(featured.content[0])"></vimeo-embed>
    </div>

    <transition-group name="project-item" tag="div">
      <div v-for="project in projects" :key="project.id" class="project-item">
        <project-banner :project="project"></project-banner>
      </div>
    </transition-group>
  </div>
</template>

<script>
import ProjectBanner from './ProjectBanner'
import VimeoEmbed from './VimeoEmbed';

export default {
  name: 'projects',
  components: {
    ProjectBanner,
    VimeoEmbed
  },
  methods: {
    isVimeo (content) {
      return content.match(/vimeo/);
    }
  },
  computed: {
    featured () {
      return !this.$route.params.category && this.$store.getters.featured;
    },
    projects () {
      try {
        if (this.$store.getters.projects.length === 0) {
          this.$router.push('/');
        }

        return this.$route.params.category
          ? this.$store.getters.projects
          : this.$store.getters.projects.filter(p => p.id !== this.$store.state.featured);
      } catch (e) {
        this.$router.push('/');
      }
    }
  }
}
</script>

<style lang="scss">
.projects {
  display: flex;
  flex-flow: wrap;

  &__featured {
    margin: 2rem 0;
  }

  & > div {
    display: flex;
    flex-flow: wrap;
    width: 100%;

    .project-item {
      width: 25%;

      @media only screen and (max-width: 512px) { 
        width: 50%;
      }
    }

    .project-item-enter, .project-item-leave-to {
      opacity: 1;
    }

    .project-item-leave, .project-item-enter-to {
      opacity: 1; 
    }
  }
}
</style>



// WEBPACK FOOTER //
// Projects.vue?2a3e731d